import api from './api';

let settingsCache = null;
let loadPromise = null;
const saveQueues = {};
const PUBLIC_PATHS = ['/', '/portal', '/portal/auto-login'];

const isPublicRoute = () => PUBLIC_PATHS.includes(window.location.pathname);

export const userSettingsService = {
  async loadAll() {
    if (isPublicRoute()) {
      settingsCache = {};
      return settingsCache;
    }
    if (settingsCache) return settingsCache;
    if (!loadPromise) {
      loadPromise = api.get('/user-settings', { skipAuthRedirect: true })
        .then(({ data }) => {
          settingsCache = data.settings || {};
          return settingsCache;
        })
        .catch(() => {
          settingsCache = {};
          return settingsCache;
        })
        .finally(() => {
          loadPromise = null;
        });
    }
    return loadPromise;
  },

  getCached(key, fallback) {
    return settingsCache && Object.prototype.hasOwnProperty.call(settingsCache, key)
      ? settingsCache[key]
      : fallback;
  },

  async get(key, fallback) {
    const settings = await this.loadAll();
    return Object.prototype.hasOwnProperty.call(settings, key) ? settings[key] : fallback;
  },

  async set(key, value) {
    if (isPublicRoute()) return value;
    settingsCache = { ...(settingsCache || {}), [key]: value };
    const previousSave = saveQueues[key] || Promise.resolve();
    const save = previousSave
      .catch(() => {})
      .then(() => api.put(`/user-settings/${encodeURIComponent(key)}`, { value }, { skipAuthRedirect: true }));
    const queuedSave = save.finally(() => {
      if (saveQueues[key] === queuedSave) delete saveQueues[key];
    });
    saveQueues[key] = queuedSave;
    await save;
    return value;
  },

  clearCache() {
    settingsCache = null;
    loadPromise = null;
  },
};
